import { render, staticRenderFns } from "./insertOrder.vue?vue&type=template&id=5b6f8a14&scoped=true&"
import script from "./insertOrder.vue?vue&type=script&lang=js&"
export * from "./insertOrder.vue?vue&type=script&lang=js&"
import style0 from "./insertOrder.vue?vue&type=style&index=0&id=5b6f8a14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f8a14",
  null
  
)

export default component.exports